import ProvidersPopup from './ProvidersPopup';

export default ProvidersPopup;
